var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, nullable_array_property, property } from 'badphraim/data/JSONStruct';
export class ewRestRequestWebLiveMesse extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.mail = '';
        /** @override */ this.name = '';
        /** @override */ this.phone = '';
    }
}
__decorate([
    nullable,
    __metadata("design:type", String)
], ewRestRequestWebLiveMesse.prototype, "attendance", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewRestRequestWebLiveMesse.prototype, "company", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], ewRestRequestWebLiveMesse.prototype, "employees", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestRequestWebLiveMesse.prototype, "mail", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestRequestWebLiveMesse.prototype, "name", void 0);
__decorate([
    property,
    __metadata("design:type", String)
], ewRestRequestWebLiveMesse.prototype, "phone", void 0);
__decorate([
    nullable_array_property(String),
    __metadata("design:type", Array)
], ewRestRequestWebLiveMesse.prototype, "services", void 0);
